module.exports = __webpack_public_path__ + "media/yaling.8e25b0de.mp4";